export const getLtv = (loanValue: number, propertyPrice: number) =>
	(loanValue / propertyPrice) * 100;
